import { type Board, type Clip } from '@air/api/types';

export type PlaceholderEntry = {
  clipIds: Clip['id'][];
  clips: Clip[];
  parentBoardId?: Board['id'];
};

const placeholdersByTask = new Map<string, PlaceholderEntry>();

export const registerPlaceholders = (localTaskId: string, clips: Clip[], parentBoardId?: Board['id']) => {
  placeholdersByTask.set(localTaskId, { clipIds: clips.map((c) => c.id), clips, parentBoardId });
};

export const getPlaceholdersForTask = (localTaskId: string): PlaceholderEntry | undefined => {
  return placeholdersByTask.get(localTaskId);
};

export const removePlaceholdersForTask = (localTaskId: string) => {
  placeholdersByTask.delete(localTaskId);
};
